/** The member's own IANA timezone, when the browser exposes it. */
export function browserTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/** 'America/Toronto' reads as 'Toronto'. */
export function zoneCity(timezone: string): string {
  return (timezone.split('/').pop() ?? timezone).replace(/_/g, ' ');
}

/** Current UTC offset of a zone, e.g. 'UTC-04:00'. Empty when unknown. */
export function zoneOffset(timezone: string, at: Date = new Date()): string {
  try {
    const part = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'longOffset',
    })
      .formatToParts(at)
      .find((item) => item.type === 'timeZoneName')?.value;
    if (!part) return '';
    const offset = part.replace('GMT', '');
    return 'UTC' + (offset || '+00:00');
  } catch {
    return '';
  }
}

/** Every zone the browser knows, always including `current` and UTC. */
export function timezoneOptions(current?: string): string[] {
  let zones: string[] = [];
  try {
    zones =
      (
        Intl as unknown as { supportedValuesOf?: (key: string) => string[] }
      ).supportedValuesOf?.('timeZone') ?? [];
  } catch {
    zones = [];
  }
  const all = new Set(zones);
  all.add('UTC');
  if (current) all.add(current);
  return [...all].sort((a, b) => a.localeCompare(b));
}
